import { FontPair } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/font-config';
import { Palette } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/palette-config';
import { ThemeProvider } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/theme-provider';
import { SplitLayoutWrapper } from './components/split-layout-wrapper';
import { SplitContentPanelBackground, SplitLayoutAccent } from './components/split-layout-accent';

type Props = {
  palette: Palette;
  fontPair: FontPair;
};

export const WeddingWebsiteSplit = ({ palette, fontPair }: Props) => (
  <ThemeProvider
    palette={palette}
    fontPair={fontPair}
    layoutVariant="split"
    preloadAllFonts
    className="@container w-full">
    <div className="relative w-full bg-[var(--ww-palette-surface-primary,#fff)]">
      <SplitContentPanelBackground />
      <SplitLayoutAccent />
      <SplitLayoutWrapper />
    </div>
  </ThemeProvider>
);
